<template>
    <div class="slack-channel-box">
        <signin-button v-if="!slack_is_signed_in" />
        <br />
        <br />
        <div v-if="slack_is_signed_in">
            <button
                class="add-channels button is-info"
                type="button"
                @click.stop="is_create_channel_modal_active = true"
            >
                <strong>Add channels</strong>
                <o-icon pack="fa" icon="plus"/>
            </button>
            <multiselect
                v-model="channel"
                deselect-label="Can't remove this value"
                track-by="id"
                label="name"
                placeholder="Select channel"
                :options="slack_channels"
                :allow-empty="false"
            >
            </multiselect>
            <br />
            <channel
                :replies_in_full_width="true"
                v-if="!!channel"
                :channel="channel.id"
                :key="channel.id"
            />
        </div>
        <o-modal
:can-cancel="['escape', 'outside', 'button']"            v-model:active="is_create_channel_modal_active"
            has-modal-card
            ref="modal"
        >
            <create-channel-modal @onSaved="handle_created" />
        </o-modal>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Multiselect from '@vueform/multiselect'
import { list_channels, } from '../slack_api'
import Channel from './Channel'
import SigninButton from './SigninButton.vue'
import CreateChannelModal from '../components/sidemenu/CreateChannelModal'

export default {
    components: {
        Channel,
        CreateChannelModal,
        Multiselect,
        SigninButton,
    },
    computed: {
        ...mapGetters([
            'slack_channels',
            'slack_is_signed_in',
        ]),
    },
    data() {
        return {
            channel: null,
            is_create_channel_modal_active: false,
        }
    },
    methods: {
        handle_created(channel) {
            this.init().then(() => {
                this.channel = channel
                this.$forceUpdate()
            })
        },
        init() {
            // if (!this.slack_is_signed_in) {
            //     return Promise.reject()
            // }
            // return list_channels().then(({ channels, }) => {
            //     channels.length && (this.channel = channels[0])
            // })
        },
    },
    mounted() {
        this.init()
    },
    watch: {
        slack_is_signed_in(value) {
            if (value) {
                this.init()
            }
        },
    },
}
</script>
<style>
.slack-channel-box .add-channels {
  margin-bottom: 8px; }
  .slack-channel-box .add-channels i {
    margin-left: 8px; }
    .slack-channel-box .add-channels i:before {
      font-weight: 700; }

</style>